export default __webpack_public_path__ + "static/intro-clip-bfe5c860bdf73ed5a5e2f6d91dd31fa9.mp4";